import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { formatHorario } from "../../utils/timeUtils";
import { handleReservation } from "../../utils/reservationUtils";
import "./styles.css";

const Agendamento = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { roomId, roomName, scheduleId, scheduleTime } = location.state || {};
  const [name, setName] = useState("");

  const handleAgendar = async () => {
    if (!name.trim()) {
      toast.error("Informe um nome para agendar a reserva");
    } else {
      if (!roomId || !scheduleId) {
        toast.error("ID da sala ou do horário inválido");
        return;
      }
      await handleReservation(roomId, scheduleId, name);
      navigate("/");
    }
  };

  return (
    <div className="agendamento">
      <h1>Confirmar reserva</h1>
      <h1>{roomName}</h1>
      <p>Horário: {formatHorario(scheduleTime, roomName)}</p>
      <input
        type="text"
        placeholder="Informe o nome para agendar a reserva"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <button onClick={handleAgendar}>Agendar</button>
    </div>
  );
};

export default Agendamento;